import { useContext } from "react";
import { useBulkDeleteFile } from "../api/bulkDeleteFile";
import { fileUploadInitialFormData } from "./../data/fileUploadData";
import { BillingUploadContext } from "../BillingUploadContext";

export const useFileDelete = () => {
  const billingUploadCtx = useContext(BillingUploadContext);
  const deleteFileMutation = useBulkDeleteFile({data: fileUploadInitialFormData});

  const deleteButtonClick = async () => {
    const formData = billingUploadCtx.userFormData ? billingUploadCtx.userFormData : fileUploadInitialFormData;
    try {
      await deleteFileMutation.mutateAsync({
        data: formData,
      }).then(() => {
        billingUploadCtx.handleChangeStatus("approved");
      }).catch((error) => {
        console.log(error);
      });
    } catch (error) {
      billingUploadCtx.handleChangeStatus("blocked");
    }
  }

  return {
    deleteButtonClick
  }
}